import { compose, pick } from 'ramda'

export const cleanRequest = item => compose(pick(['id', 'name', 'namePlural', 'icon']))(item)
